export default __webpack_public_path__ + "static/media/exterior (25).054e2432.jpg";